import $ from 'jquery'
import _ from 'lodash';
import { createContext, useEffect, useState } from "react";
import { Switch } from "react-router";
import { NavLink } from "react-router-dom";
import { Button, Dropdown } from "semantic-ui-react";
import { TestingVisualSearchParameterContext } from "../../context";
import { restRequest } from "../../http";
import { DropdownOption } from "../../models/testing_model";
import { RouteWithSubRoutes } from "../../routes";
import { TestingDataMenu } from '../commons/TestingDataMenu';
import { notificationControl } from '../../controls/notification-control';
import { dialogControl } from '../../controls/dialog-control';
import { parseQueryObject } from '../../utils';


export function TestingMain(props: { match: any, routes: any[] }) {
    const id = props.match.params.testing_id - 0;

    const sProjectDropdownOptions = useState<DropdownOption[]>([]);
    const sQueryStr = useState('');
    const [searchParameters, setSearchParameters] = useState<any>(parseQueryObject());

    useEffect(() => {
        restRequest<DropdownOption[]>('svn_repository/result_dropdown_options').then(sProjectDropdownOptions[1])
    }, []);

    useEffect(() => {
        let queryValues = _.pickBy(searchParameters, v => !_.isNull(v) && !_.isUndefined(v) && v !== '' && v !== '_none');
        const tabPath = queryValues.tab_path as string;
        if (tabPath) {
            const exculdeTabPathParameterKeys = Object.keys(queryValues).filter(key => {
                const tabPathMatch = key.match(/^t(_\d)+/)
                if (tabPathMatch) {
                    const keyTabPath = tabPathMatch[0];
                    if (!keyTabPath.startsWith(tabPath) && !tabPath.startsWith(keyTabPath)) {
                        return true;
                    }
                }

                return false;
            });

            queryValues = _.omit(queryValues, 'tab_path', ...exculdeTabPathParameterKeys);
        }

        sQueryStr[1]($.param(queryValues));
    }, [searchParameters])

    let selected = '';
    out: for (const p of sProjectDropdownOptions[0]) {
        for (const s of p.children) {
            for (const o of s.children) {
                if (o.id === id) {
                    selected = `${p.name} -> ${s.name} -> ${o.name}`;
                    (window as any).test_info = {product: p.name, order: s.name}
                    window.document.title = selected;
                    break out;
                }
            }
        }
    }

    if (!selected) {
        window.document.title = 'Lewitt Production Testing';
    }

    return (
        <div className="app" style={{ padding: "1rem", position: 'relative' }}>
            <TestingVisualSearchParameterContext.Provider value={[searchParameters, setSearchParameters]}>
                <Switch>
                    {props.routes.map((route: any, i: any) => (
                        <RouteWithSubRoutes key={i} {...route} customParameters={{ id }} />
                    ))}
                </Switch>
            </TestingVisualSearchParameterContext.Provider>

            <div style={{ position: 'absolute', left: '2rem', top: '3px', zIndex: 100 }}>
                <TestingDataMenu selectedText={selected} options={sProjectDropdownOptions[0]} dashboardMenu/>
                <Button.Group size="mini" compact>
                    <Button size="mini" as={NavLink} to={"overview?" + sQueryStr[0]}>Overview</Button>
                    <Button size="mini" as={NavLink} to={"detail?" + sQueryStr[0]}>Detail</Button>
                </Button.Group>
            </div>

            <div style={{ position: 'absolute', right: '2rem', top: '3px', zIndex: 100 }}>
                <Button size="mini" as="a" icon="share" onClick={e => {
                    e.stopPropagation();
                    e.preventDefault();

                    const to_testing_url = window.location.href.split('?')[0];

                    navigator.clipboard.writeText(to_testing_url + '?' + sQueryStr[0]).then(() => {
                        notificationControl.showSuccess('The URL have been copied!')
                    }).catch(err => {
                        dialogControl.alert(`The url is: ${to_testing_url}?${sQueryStr[0]}`)
                    })
                }}></Button>
            </div>
        </div>
    );
}
